import React from 'react';
import { Helmet } from 'react-helmet-async';
import Card from '../components/UI/Card';
import { Shield, Lock, Server, EyeOff } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <div className="tool-page">
            <Helmet>
                <title>Privacy Policy - OnlineToolSphere</title>
                <meta name="description" content="Privacy Policy for OnlineToolSphere. We prioritize your privacy with client-side processing." />
                <meta property="og:title" content="Privacy Policy - OnlineToolSphere" />
                <meta property="og:description" content="Privacy Policy for OnlineToolSphere. We prioritize your privacy with client-side processing." />
                <meta property="og:url" content="https://onlinetoolsphere.com/privacy/" />
                <meta name="twitter:title" content="Privacy Policy - OnlineToolSphere" />
                <meta name="twitter:description" content="Privacy Policy for OnlineToolSphere. We prioritize your privacy with client-side processing." />
            </Helmet>

            <div className="container">
                <div className="tool-header">
                    <h1>Privacy Policy</h1>
                    <p className="tool-subtitle">Transparency and security by design</p>
                </div>

                <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                    <Card className="mb-8">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                            <Shield size={32} className="text-gradient" />
                            <h2>Our Commitment to Privacy</h2>
                        </div>
                        <p style={{ color: 'var(--text-muted)', marginBottom: '1rem' }}>
                            At OnlineToolSphere, we believe that your data belongs to you. We have designed our tools to operate entirely within your browser, ensuring that sensitive information never leaves your device.
                        </p>
                    </Card>

                    <div style={{ display: 'grid', gap: '1.5rem', marginTop: '2rem' }}>
                        <Card>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <div style={{ minWidth: '40px' }}>
                                    <Lock size={24} style={{ color: 'var(--accent)' }} />
                                </div>
                                <div>
                                    <h3 style={{ marginBottom: '0.5rem' }}>Client-Side Processing</h3>
                                    <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem' }}>
                                        All calculations, conversions, and transformations happen directly in your web browser using JavaScript. We do not send your files, text, or data to any remote server for processing.
                                    </p>
                                </div>
                            </div>
                        </Card>

                        <Card>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <div style={{ minWidth: '40px' }}>
                                    <Server size={24} style={{ color: 'var(--accent)' }} />
                                </div>
                                <div>
                                    <h3 style={{ marginBottom: '0.5rem' }}>No Data Collection</h3>
                                    <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem' }}>
                                        We do not store, record, or analyze the content you process with our tools. Once you close the tab or refresh the page, your data is gone from the application memory.
                                    </p>
                                </div>
                            </div>
                        </Card>

                        <Card>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <div style={{ minWidth: '40px' }}>
                                    <EyeOff size={24} style={{ color: 'var(--accent)' }} />
                                </div>
                                <div>
                                    <h3 style={{ marginBottom: '0.5rem' }}>No Tracking</h3>
                                    <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem' }}>
                                        We do not use invasive tracking cookies or third-party analytics that monitor your usage of the tools. Your usage patterns remain private.
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div style={{ marginTop: '3rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                        <p>Last updated: {new Date().toLocaleDateString()}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
